import { useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import Box from '@mui/system/Box';

import { Alert as AlertModel } from '../models/Alert';
import { navbarHeightAtom } from '../utils/AtomConfig';
import Constants from '../utils/Constants';
import { SharePointService } from '../utils/SharePointService';
import { Alert } from './Alert';
import { NavMenu } from './NavMenu';

export const Layout: React.FunctionComponent = ({ children }) => {
  const sharepointService = SharePointService.Instance;

  const navbarHeight = useAtomValue(navbarHeightAtom);

  const [alerts, setAlerts] = useState<Array<AlertModel>>([]);

  const { data } = useQuery(
    Constants.QUERY_KEYS.ALERTS,
    () => sharepointService.getAlerts(),
    {
      ...Constants.BASE_DISABLE_REFETCH_SETTINGS,
    }
  );

  useEffect(() => {
    if (data) {
      setAlerts(data);
    }
  }, [data]);

  function handleCloseAlert(id: number) {
    setAlerts(alerts.filter((alert) => alert.id !== id));
  }

  return (
    <div>
      {/* Navbar */}
      <NavMenu />

      {/* Alerts */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          position: 'fixed',
          zIndex: 1000,
        }}
      >
        {alerts.map((alert) => (
          <Box key={alert.id} marginTop={`${navbarHeight}px`}>
            <Alert
              key={alert.id}
              alert={alert}
              onClose={() => handleCloseAlert(alert.id)}
            />
          </Box>
        ))}
      </Box>

      {/* Main content */}
      <Box>{children}</Box>
    </div>
  );
};
